import { useEffect } from 'react';
import { useMatches } from 'react-router';
import { env } from '@/config/env';
import { getRouteHandle, resolveRouteText } from './routeHandle';

export interface Breadcrumb {
  id: string;
  label: string;
  pathname: string;
}

export function useBreadcrumbs(): Breadcrumb[] {
  return useMatches().flatMap((match) => {
    const label = resolveRouteText(getRouteHandle(match)?.breadcrumb, match.params);
    return label === undefined ? [] : [{ id: match.id, label, pathname: match.pathname }];
  });
}

/** Sets `document.title` from the deepest matched route that declares a title. */
export function useRouteDocumentTitle(): void {
  const matches = useMatches();
  const title = matches
    .map((match) => resolveRouteText(getRouteHandle(match)?.title, match.params))
    .findLast((value) => value !== undefined);

  useEffect(() => {
    document.title = title ? `${title} · ${env.appName}` : env.appName;
  }, [title]);
}
